import { partnerServices } from "../../config/axios";
import {
    UPLOAD_TO_GENERATE_LINK_REQUEST,
    UPLOAD_TO_GENERATE_LINK_SUCCESS,
    UPLOAD_TO_GENERATE_LINK_FAILURE,
    RESET_UPLOAD_TO_GENERATE_LINK,
} from "../types/index";

// ── Action Creator ─────────────────────────────────────────────────────────────
export const uploadToGenerateLinkAction = (requestData, authToken) => async (dispatch) => {
    dispatch({ type: UPLOAD_TO_GENERATE_LINK_REQUEST });

    await partnerServices
        .post("uploadToGenerateLink", requestData, {
            headers: { AuthToken: authToken },
        })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch({
                        type: UPLOAD_TO_GENERATE_LINK_SUCCESS,
                        payload: res.data,
                    });
                    break;
                default:
                    dispatch({
                        type: UPLOAD_TO_GENERATE_LINK_FAILURE,
                        payload: res.data,
                    });
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: UPLOAD_TO_GENERATE_LINK_FAILURE,
                payload: err.message,
            });
        });
};

// ── Reset Action ───────────────────────────────────────────────────────────────
export const resetUploadToGenerateLink = () => (dispatch) => {
    dispatch({ type: RESET_UPLOAD_TO_GENERATE_LINK });
};